import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../utils/constant";

const groups = {
  dashboard: ["/dashboard"],
  reports: ["/reports"],
  users: ["/roles", "/permissions", "/branch", "/branch/users"],
  master: [
    "/suppliers",
    "/customers",
    "/setup/taxes",
    "/setup/units",
    "/brands",
    "/product-attributes",
  ],
  import: ["/import", "/import/images"],
  purchases: ["/setup/categories", "/raw-products", "/raw-products-stock"],
  finalProducts: ["/categories", "/products"],
  purchaseSystem: [
    "/payment/supplier",
    "/pushed-purchase",
    "/approved-purchase",
    "/raw-products/stock",
    "/raw-products/purchases",
  ],
  salesSystem: [
    "/reports/sales",
    "/reports/stock",
    "/tenders/sale",
    "/tenders/cost",
    "/tenders/order",
    "/tenders/delivered",
    "/tenders/production",
  ],
  accounts: [
    "/accounts/sales-bills",
    "/accounts/bills",
    "/accounts/credit-notes",
    "/accounts/assets",
  ],
  tasks: ["/task/assigned-to-you", "/task/assigned-by-you"],
};

const searchableRoutes = Object.entries(groups).flatMap(([group, routes]) =>
  routes.map((path) => ({
    group,
    path,
    label: path.replaceAll("/", " ").replace("-", " ").trim(),
  }))
);

const GlobalSearch = ({ isPOSRoute, companyName }) => {
  const [query, setQuery] = useState("");
  const [session, setSession] = useState("");
  
  const navigate = useNavigate();

  // CALL API
  useEffect(() => {
    const getSession = async () => {
      const companyId = localStorage.getItem("companyID");
      try {
        const res = await axios.get(
          `${API_URL}/companies/financial/session/${companyId}`
        );

        setSession(res.data.session);
      } catch (error) {
        console.error("Session fetch error", error);
      }
    };

    getSession();
  }, []);

  const results = searchableRoutes.filter(
    (r) =>
      r.path.toLowerCase().includes(query.toLowerCase()) ||
      r.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleNavigate = (path) => {
    navigate(path);
    setQuery("");
  };

  return (
    <li className="nav-item nav-searchinputs d-flex gap-3">
      <div className={`top-nav-search ${isPOSRoute ? "d-none" : ""}`}>
        <form className="dropdown">
          <div
            className="searchinputs input-group dropdown-toggle"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
          >
            <input
              type="text"
              placeholder="Search routes..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <span className="input-group-text">
              <i className="ti ti-search" />
            </span>
          </div>

          <div
            className={`dropdown-menu search-dropdown ${
              query ? "show" : ""
            }`}
          >
            {query && results.length === 0 && (
              <p className="px-3 py-2 text-muted">No routes found</p>
            )}

            {results.map((item, index) => (
              <div
                key={index}
                className="dropdown-item cursor-pointer"
                onClick={() => handleNavigate(item.path)}
              >
                <small className="text-muted d-block">
                  {item.group.toUpperCase()}
                </small>
                <strong style={{ textTransform: "capitalize" }}>
                  {item.label}
                </strong>
              </div>
            ))}
          </div>
        </form>
      </div>

      <h3 className="company-name mt-1 ml-2">
        {companyName} : {session}
      </h3>
    </li>
  );
};

export default GlobalSearch;